export default __webpack_public_path__ + "static/dirtCoffin-a968dcddc2e883bf2c4a30d1f9640900.jpeg";